import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ProductReferenceService } from '@spartacus/core';
import { CmsComponentData,  CurrentProductService,  ProductReferencesComponent } from '@spartacus/storefront';
import { filter, tap } from 'rxjs/operators';
import { UigProductReferencesComponentData} from '../uig-product.models';

@Component({
    selector: 'app-uig-product-references',
    templateUrl: './uig-product-references.component.html',
    styleUrls: ['./uig-product-references.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class UigProductReferencesComponent extends ProductReferencesComponent implements OnInit {

  public productsVisibleAtOnce: number = 1;
  public showSummary: boolean = false;
  private extendedComponentData$ = this.componentData.data$;

  constructor (
    protected componentData: CmsComponentData<UigProductReferencesComponentData>,
    protected currentProductService: CurrentProductService,
    protected productReferenceService: ProductReferenceService
  ) {
    super(componentData, currentProductService, productReferenceService);
  }

  ngOnInit(): void {
    this.extendedComponentData$
      .pipe(
        filter((data) => data != null),
        tap((data) => {
          this.productsVisibleAtOnce = data.productsVisibleAtOnce;
          this.showSummary = data.showSummary;
        })
      )
      .subscribe();
  }

  public getItemWidth(): string {
    const widthPercentageValue: number = Math.floor(100 / this.productsVisibleAtOnce);
    return `${widthPercentageValue}%`;
  }
}
